import { useToastItem } from './toast.hook';
import { toastStyles } from './toast.styles';
import { CloseIcon, TOAST_ICON_BY_TYPE } from './icons';
import { TOAST } from './utils';
import { sharedTestId } from '@/utils';
import type { TToast } from './toast.types';

type TToastItemConfig = {
	toast: TToast;
	onRemove: (id: string) => void;
};

const ToastItem = ({ toast, onRemove }: TToastItemConfig) => {
	const { isExiting, handleClose } = useToastItem({ toast, onRemove });

	return (
		<div
			role="status"
			aria-live="polite"
			className={toastStyles.container(isExiting)}
			data-testid={sharedTestId.toast(toast.id)}
		>
			<div className={toastStyles.iconSlot}>{TOAST_ICON_BY_TYPE[toast.type]}</div>

			<div className={toastStyles.body}>
				<span className={toastStyles.title}>
					{toast.title}
				</span>
				{toast.description && (
					<span className={toastStyles.description}>
						{toast.description}
					</span>
				)}
			</div>

			{toast.action && (
				<button
					type="button"
					className={toastStyles.actionButton}
					onClick={toast.action.onClick}
					data-testid={sharedTestId.toastAction(toast.id)}
				>
					{toast.action.label}
				</button>
			)}

			<button
				type="button"
				className={toastStyles.closeButton}
				onClick={handleClose}
				aria-label={TOAST.CLOSE_ARIA}
				data-testid={sharedTestId.toastClose(toast.id)}
			>
				<CloseIcon />
			</button>
		</div>
	);
};

ToastItem.displayName = 'ToastItem';

export { ToastItem };
export type { TToastItemConfig };
